import React, {FC} from 'react';
import {PageHeaderWrapper} from "./styled";

type Props = {
    children: React.ReactNode;
};

const PageHeader: FC<Props> = (props) => {
    return (
        <PageHeaderWrapper>
            {props.children}
        </PageHeaderWrapper>
    );
};

export default PageHeader;
